import React from 'react';

import Icon from '../Icon/Icon';

const CloseCircleIcon = ({fill, ...props}) => {
    return (
        <Icon width='32' height='32' viewBox='0 0 32 32' fill='none' {...props}>
            <foreignObject x='-10' y='-10' width='50' height='50'>
                <div
                    xmlns='http://www.w3.org/1999/xhtml'
                    style={{
                        clipPath: 'url(#bgblur_0_703_8028_clip_path)',
                        height: '100%',
                        width: '100%',
                    }}
                />
            </foreignObject>
            <circle data-figma-bg-blur-radius='10' cx='15' cy='15' r='15' fill={fill} fillOpacity='0.1' />
            <g clipPath='url(#clip1_703_8028)'>
                <path
                    d='M9.75 20.25L20.25 9.75M9.75 9.75L20.25 20.25'
                    stroke='#FFFDFB'
                    strokeWidth='1.5'
                    strokeLinecap='round'
                    strokeLinejoin='round'
                />
            </g>
            <defs>
                <clipPath id='bgblur_0_703_8028_clip_path' transform='translate(10 10)'>
                    <circle cx='15' cy='15' r='15' />
                </clipPath>
                <clipPath id='clip1_703_8028'>
                    <rect width='12' height='12' fill='white' transform='translate(9 9)' />
                </clipPath>
            </defs>
        </Icon>
    );
};

export default CloseCircleIcon;
